import React from 'react';
import { DonutLegendChart } from '@/components/ui/DonutLegendChart';

export function ProjectMaterialsStats() {
  const statsData = [
    { name: 'Cây xanh', value: 520, color: '#10b981' },
    { name: 'Hệ thống tưới', value: 300, color: '#3b82f6' },
    { name: 'Phân bón', value: 150, color: '#f59e0b' },
    { name: 'Vật tư điện', value: 130, color: '#a855f7' },
    { name: 'Trang trí', value: 100, color: '#f97316' },
    { name: 'Khác', value: 50, color: '#94a3b8' },
  ];

  return (
    <DonutLegendChart
      title="Cơ cấu giá trị vật tư theo danh mục"
      centerValue="1.250M"
      centerLabel="Tổng giá trị (VND)"
      data={statsData}
      total={1250}
    />
  );
}
